import React from 'react'
import Container from 'react-bootstrap/Container'
import {Colors} from '../editable-stuff/constants'
import {mainBody} from '../editable-stuff/config'

const Footer = (props) => {
    const bgStyle = {backgroundColor: Colors.SmokeWhite}

    return (
        <footer style={bgStyle} className="mt-auto py-5 text-center ">
            <Container>
                {props.children}
                <i className="fas fa-laptop-code"/> with <i className="fas fa-heart"/> by{' '}
                <a
                    rel="noopener"
                    href="https://github.com/felipechava"
                > <span className="badge bg-dark">
            {`<${mainBody.firstName} ${mainBody.lastName}/>`}
          </span>
                </a>{' '}using <i className="fab fa-react"/>
            </Container>
        </footer>
    )
}

export default Footer